import { useCallback, useEffect, useMemo, useState } from "react";

import type { UserMe } from "simplydo/interfaces/types/userTypes";

import util from "utils/utils";

import type { IdeaDetail, IdeaEditState } from "../types";

export const useEditControls = (
  user: UserMe | null,
  idea: IdeaDetail | undefined,
): [IdeaEditState, (isEditing: boolean) => void] => {
  const [editState, setEditState] = useState<IdeaEditState>({
    ideaInitialised: false,
    isEditing: true,
    canEdit: false,
  });
  const canEdit = useMemo(() => util.canEditIdea(user, idea), [user, idea]);
  const ideaSubmitted = !!idea?.isSubmitted;
  const ideaExists = !!idea;

  useEffect(() => {
    setEditState((prevState) => ({
      ...prevState,
      ideaInitialised: ideaExists,
    }));
  }, [ideaExists]);

  useEffect(() => {
    setEditState((prevState) => ({
      ...prevState,
      isEditing: canEdit && !ideaSubmitted,
      canEdit,
    }));
  }, [canEdit, ideaSubmitted]);

  const setEditing = useCallback((isEditing: boolean) => {
    setEditState((prevState) => ({
      ...prevState,
      isEditing: prevState.canEdit && isEditing,
    }));
  }, []);

  return [editState, setEditing];
};
